export default __webpack_public_path__ + "static/media/pin-blue.d6ee74d6.svg";